import { Search } from "@mui/icons-material";
import ClearIcon from '@mui/icons-material/Clear';
import { Tooltip } from "@mui/material";
import { useRef } from "react";
import { useUpdateEffect } from "usehooks-ts";

export function CustomSearch(props){
  const expandable = props?.expandable
  let expand = expandable ? 'expandable' : '' 
  let inputRef = useRef(null);

  useUpdateEffect(() => {
    if (props.focusOnMount === true) {
      inputRef.current.focus();
    }
  }, [props.focusOnMount])
  
  return (
    <div className={`custom-search-container ${expand}`} style={ props?.styles && props?.styles?.container ? props?.styles?.container : {}  }>
      <Search sx={{ paddingRight: '5px', fontSize: '27px', color: props?.styles && props?.styles?.input?.color ? props?.styles?.input?.color : '#828282', alignSelf: 'center', }} />
      <input ref={inputRef} className="custom-search-input" style={ props?.styles && props?.styles?.input ? props?.styles?.input : {} } placeholder={props?.placeholder ? props?.placeholder : "Search..."} value={props.inputValue} onChange={(e) => props.updateInputValue(e.target.value)} />
      { props.inputValue !== '' ? <Tooltip title="Clear Search" >
        <ClearIcon 
          onClick={(e) => {
            e.stopPropagation()
            props.updateInputValue('')
          }} 
          sx={{ color: props?.styles && props?.styles?.input?.color ? props?.styles?.input?.color : '#828282', justifySelf: 'flex-end', alignSelf: 'center', fontSize: '18px' }} />
      </Tooltip> : null }
    </div>
  )
}
